export default __webpack_public_path__ + "static/media/PingFang-SC.d1e520a6.ttf";